export const TRADE_IN_INTELLIGENCE_MAX_HOUSEHOLD_VEHICLES = 10;

export const TRADE_IN_INTELLIGENCE_LOOKBACK_DAYS = 90;

export type TradeInValuationRecordServiceData = {
    gcid: string | null;
    householdId: string | null;
    householdIdType: string | null;
    householdConfidence: string | null;
    visitorIdScore: number | null;
    householdVehicleCount: number | null;
    vehicleKey: string | null;
    kbbVehicleId: string | null;
    vin: string | null;
    year: number | null;
    make: string | null;
    model: string | null;
    mileage: number | null;
    condition: string | null;
    tradeValueLow: number | null;
    tradeValueMid: number | null;
    tradeValueHigh: number | null;
    presentedAt: string | null;
    rankInGcid: number | null;
};

export type TradeInIntelligencePushState = 'ready' | 'empty' | 'error';

export type TradeInIntelligenceFailureReason = 'config-missing' | 'snowflake-error' | 'timeout' | 'unknown';

export type TradeInIntelligenceCompletionServiceData = {
    state: TradeInIntelligencePushState;
    dealId: string;
    count: number;
    records: TradeInValuationRecordServiceData[];
    dataAsOfNote: string;
    failureReason?: TradeInIntelligenceFailureReason;
    requestId?: string;
};

export type TradeInIntelligenceStatus = 'idle' | 'pending' | 'settled';

export type TradeInIntelligenceState = {
    status: TradeInIntelligenceStatus;
    records: TradeInValuationRecordServiceData[];
    requestedAtMs: number | null;
    correlationId: string | null;
};

export type TradeInIntelligenceResolution = 'match' | 'headsUp' | 'mismatch' | 'nothing';

export type TradeInIntelligenceMatchMethod = 'vin' | 'ymm';

export type TradeInIntelligenceDisplayReason =
    | 'no_records'
    | 'no_usable_records'
    | 'not_describable'
    | 'incomplete_trade'
    | 'different_vehicle';

export type TradeInIntelligenceDisplay = {
    resolution: TradeInIntelligenceResolution;
    reason: TradeInIntelligenceDisplayReason | null;
    matchMethod: TradeInIntelligenceMatchMethod | null;
    shownRank: number | null;
    recordCount: number;
    candidateCount: number;
    enteredTradeCount: number;
};

export type TradeInIntelligenceRange = {
    low: string;
    likely: string;
    high: string;
};

export type TradeInIntelligenceAnalyticsRecord = Pick<
    TradeInValuationRecordServiceData,
    'vin' | 'tradeValueLow' | 'tradeValueMid' | 'tradeValueHigh'
>;

export type TradeInIntelligenceRowState =
    | { resolution: 'match'; range: TradeInIntelligenceRange; seenAt: string; enteredInputs: string | null }
    | {
          resolution: 'headsUp';
          range: TradeInIntelligenceRange;
          seenAt: string;
          enteredInputs: string | null;
          vehicle: string;
      }
    | { resolution: 'mismatch' }
    | { resolution: 'nothing' };
